import { TranslatePipe } from '../../filters/translate.pipe';
import { CardCreatedSurveysComponent } from '../../components/card-created-surveys/card-created-surveys.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelDirective } from '../../directives/panel.directive';
import RoutingService from '../../services/routing.service';
import RestService from "../../services/core-rest.service";
import AngularHelperService from "../../services/angular-helper.service";
import { RouterLink } from '@angular/router';
import DialogServices from '../../services/dialog.service';
import {ModalSelectedSurveyComponent} from "../../components/modal-selected-survey/modal-selected-survey.component";
import Session from "../../utils/session.service";

@Component({
	standalone: true,
	selector: 'employee-surveys',
	templateUrl: './employee-surveys.component.html',
	imports: [ CommonModule, TranslatePipe, CardCreatedSurveysComponent, PanelDirective, RouterLink]
})
export default class EmployeeSurveysView implements OnInit {
	private routingService: RoutingService = inject(RoutingService);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogServices: DialogServices = inject(DialogServices);
	private session: Session = inject(Session);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.openModalDialog = this.openModalDialog;
		this.routingService.validateAccess('employees').then(() => {});
		this.vm.user = this.session.getSession().user;
		this.vm.language = this.vm.user.deviceLanguage;
		this.angularHelperService.createTimer(() => {
			this.restService.getSurveySupportsQuestionnaireSearch({language: this.vm.language})
				.then((response) => {
					this.vm.surveys = (response || []).filter((survey) => !this.isComplianceAssessment(survey && survey.codeName));
				})
				.catch((error) => {
					console.log(error);
				});
		}, 200);

	}

	openModalDialog(surveyCodeName, surveyName) {
		 this.dialogServices.show({
			controller: ModalSelectedSurveyComponent,
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false,
			 width: '500px',
			questionnaireCode: surveyCodeName,
			questionnaireName: surveyName
		});
	}

	isComplianceAssessment(codeName) {
		return (codeName || '').toString().toUpperCase().replace(/[\s-]+/g, '_') === 'COMPLIANCE_ASSESSMENT';
	}
	
}
